export const VIEWS = {
    SELECT_USER_GROUP: 'SELECT_USER_GROUP',
    SELECT_USER_ROLE: 'SELECT_USER_ROLE',
    SELECT_BUSINESS_INTERESTS: 'SELECT_BUSINESS_INTERESTS',
    SELECT_EDUCATION_INTERESTS: 'SELECT_EDUCATION_INTERESTS',
    BUSINESS_CONTACTS: 'BUSINESS_CONTACTS',
    EDUCATION_CONTACTS: 'EDUCATION_CONTACTS',
    WHAT_IS: 'WHAT_IS',
}

export const BUSINESS_STEPS_COUNT = 3
export const EDUCATION_STEPS_COUNT = 5
